// NWS Alerts + local conditions helpers (client-side, no key required)
export const fetchNWSActive = async () => {
  try {
    const r = await fetch("https://api.weather.gov/alerts/active?status=actual&message_type=alert,update", {
      headers: { Accept: "application/geo+json" },
    });
    if (!r.ok) return [];
    const j = await r.json();
    return (j.features || []).map(f => ({
      id: f.id || f.properties?.id,
      event: f.properties?.event,
      headline: f.properties?.headline,
      severity: f.properties?.severity,
      certainty: f.properties?.certainty,
      urgency: f.properties?.urgency,
      areaDesc: f.properties?.areaDesc,
      sent: f.properties?.sent,
      expires: f.properties?.expires,
      description: f.properties?.description,
      instruction: f.properties?.instruction,
      geometry: f.geometry,
    })).filter(a => a.event);
  } catch (e) { return []; }
};

export const eventColor = (event) => {
  const e = (event || "").toLowerCase();
  if (e.includes("tornado") && e.includes("warning")) return { fill: "#ef4444", stroke: "#fca5a5" };
  if (e.includes("tornado")) return { fill: "#f59e0b", stroke: "#fcd34d" };
  if (e.includes("severe thunderstorm warning")) return { fill: "#f59e0b", stroke: "#fde68a" };
  if (e.includes("flash flood") || e.includes("flood warning")) return { fill: "#10b981", stroke: "#6ee7b7" };
  if (e.includes("winter storm") || e.includes("blizzard")) return { fill: "#38bdf8", stroke: "#bae6fd" };
  if (e.includes("fire")) return { fill: "#f97316", stroke: "#fdba74" };
  return { fill: "#a3a3a3", stroke: "#e5e5e5" };
};

export const summarizeCounts = (alerts) => {
  const counts = {};
  alerts.forEach(a => {
    const e = a.event;
    counts[e] = (counts[e] || 0) + 1;
  });
  return counts;
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const diff = (Date.now() - new Date(iso).getTime()) / 60000;
  if (diff < 1) return "now";
  if (diff < 60) return `${Math.floor(diff)}m`;
  return `${Math.floor(diff/60)}h`;
};
